import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { uploadService } from './../../../../shared/uploadService';
import { AddingWithAttatchementsBaseComponent } from '../../../../shared/Components/adding-with-attatchements-base/adding-with-attatchements-base.component';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { FileVm } from '../../../../shared/Models/fileVm';
import { Router } from '@angular/router';
import { Institation } from '../../Model/institution';
import { AddCentersComponent } from '../../../Centers/Components/add-centers/add-centers.component';
import { InstitutionService } from '../../Service/InstitationService';
@Component({
  selector: 'add-institution',
  templateUrl: './add-institution.component.html',
  styleUrls: ['./add-institution.component.scss'],
})
export class AddInstitutionComponent extends AddingWithAttatchementsBaseComponent implements OnInit {
  model: Institation;
  isEdit = false;
  formData: FormData = new FormData();
  isLoading: boolean = false;
  newMobile: string = '';
  newWhatsapp: string = '';
  newLandline: string = '';
  constructor(
    private route: Router,
    public diagRef: NbDialogRef<AddCentersComponent>,
    public service: InstitutionService,
    public toast: NbToastrService,
    private uploadService: uploadService
  ) {
    super(service, null);
  }

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachments });
    }
    if (!this.isEdit) {
      this.model = {} as Institation;
      this.model.name = '';
      this.model.nameEN = '';
      this.model.mobile = [];
      this.model.whatsapp = [];
      this.model.landline = [];
      this.model.email = '';
      this.model.website = '';
      this.model.attachments = [] as FileVm[];
      this.model.link = '';
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    }
  }

  close() {
    this.diagRef.close();
  }

  isAttachementsValid() {
    if (!this.uploadService.isFilesEmpty() || !this.uploadService.isPrevAttachementsEmpty()) return true;

    return false;
  }

  addMobile() {
    if (this.newMobile) {
      if (!this.model.mobile) this.model.mobile = [];
      this.model.mobile.push(this.newMobile);
      this.newMobile = '';
    }
  }

  addWhatsapp() {
    if (this.newWhatsapp) {
      if (!this.model.whatsapp) this.model.whatsapp = [];
      this.model.whatsapp.push(this.newWhatsapp);
      this.newWhatsapp = '';
    }
  }

  addLandline() {
    if (this.newLandline) {
      if (!this.model.landline) this.model.landline = [];
      this.model.landline.push(this.newLandline);
      this.newLandline = '';
    }
  }

  removeMobile(item) {
    this.model.mobile = this.model.mobile.filter((x) => x !== item);
  }

  removeWhatsapp(item) {
    this.model.whatsapp = this.model.whatsapp.filter((x) => x !== item);
  }

  removeLandline(item) {
    this.model.landline = this.model.landline.filter((x) => x !== item);
  }

  save(form) {
    this.isLoading = true;
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([attachments$])
      .pipe(
        catchError(() => {
          console.log('error here in combine latest ');
          this.isLoading = false;
          return of(null);
        }),

        switchMap(([img]) => {
          // Update the model with the uploaded image and attachments
          // this.model.attachements = {
          //   fileName: img.fileName,
          //   originalFileName: img.originalFileName,
          // } as FileVm;

          this.model.attachments = img;
          let fileType = this.uploadService.SelectFileType(this.model.attachments[0].fileName);
          if (fileType != 'photo') {
            this.toast.danger(' يرجي اختيار صورة فقط ', 'خطأ', { status: 'success', duration: 3000 });
            return;
          }
          // .res.map((ele:FileVm) => { return {
          //   originalFileName:ele ,
          //   fileName :ele
          // }});

          // Return the observable that saves the entity
          // return this.saveEntity(this.model);

          return this.saveEntity(this.model);
        }),
        tap(([img, attachments]) => {})
      )
      .subscribe(
        (res) => {
          this.isLoading = false;

          this.diagRef.close('true');
          this.toast.show('تم إضافة مراكز', '', { status: 'success', duration: 3000 });
        },
        () => {
          this.isLoading = false;

          this.diagRef.close('true');
        }
      );
  }

  saveEntity(model): Observable<any> {
    return this.service.post(model);
  }

  update() {
    this.isLoading = true;
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([attachments$])
      .pipe(
        switchMap(([attachments]) => {
          // Update the model with the uploaded image and attachments

          this.model.attachments = attachments;
          let fileType = this.uploadService.SelectFileType(this.model.attachments[0].fileName);
          if (fileType != 'photo') {
            this.toast.danger(' يرجي اختيار صورة فقط ', 'خطأ', { status: 'success', duration: 3000 });
            return;
          }
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل المركز بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل المركز ', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }
}
